import { Arrivals } from '@/coreDomainsModule/entities/arrival';
import { IBusinessBase, RequiredBusinessProperty } from '@/coreDomainsModule/entities/businessBase';
import { IInventory } from '@/coreDomainsModule/entities/inventory';
import { IForecast } from '@/coreDomainsModule/entities/forecast';
import { SalesResults } from '@/coreDomainsModule/entities/salesResults';

/**
 * 取引を表すレコードのヘッダー
 * @property organizationId - 企業ID
 * @property dataId - 取引ID
 * @property dataType - レコードの種類(本当は必須だが、linterが警告するのでoptionalにしている)
 * @property updatedAt - 更新日時
 * @property removeAt - 削除日時
 * @property deleted - 削除されたかどうか
 */
interface IOrganizationRecordHeader {
  organizationId: string;
  dataId: string;
  dataType: string | undefined;
  updatedAt: number | undefined;
  createdAt: number | undefined;
  removeAt: number | undefined;
  deleted: boolean | undefined;
}

const organizationHeaderProperties = [
  // aggregator.tsで利用する
  'organizationId',
  'dataId',
  'dataType',
  //'updatedAt',  // updatedAtだけはサーバで書き込むので不要
  'removeAt',
  'deleted',
] as const;

/**
 * DBで扱うときのレコードの型
 */
type IOrganizationRecord = (IBusinessBase | IForecast | IInventory | Arrivals | SalesResults) &
  IOrganizationRecordHeader &
  RequiredBusinessProperty;

/**
 * IOrganizationRecordであることを保証する
 * @param value - 任意の値
 */
function isIOrganizationRecordHeader(value: object): value is IOrganizationRecordHeader {
  /*TODO: ISharingRecordHeaderが持つべきものを明確にする */
  return true;
}

export type { IOrganizationRecordHeader };
export { organizationHeaderProperties, isIOrganizationRecordHeader };
export type { IOrganizationRecord };
